import React, { useContext } from 'react';
import { EMPTY_OBJECT, ModalContext, CustomFooter, BUTTON_LABELS } from 'commons-ui';
import { IHandlerAction, IPermissionHandlerParams } from 'models/settingsV2.model';
import useHandler from '../useHandlers';
import { ACTION_IDS } from '../../../../../settingsV2Constant';
import { ESettingV2URL } from '../../../../../settingsV2Enum';

export const makeActionHandler = (action: IHandlerAction, params: IPermissionHandlerParams) => {
	const { history, rowData = EMPTY_OBJECT } = params;
	const { setModalConfig } = useContext(ModalContext);
	const { onAgreeDeletePermission, onDisAgreeDeletePermission } = useHandler(params);
	switch (action.id) {
		case ACTION_IDS.EDIT:
			return () => {
				history.push({
					pathname: ESettingV2URL.EDIT_PERMISSION_URL,
					state: {
						rowData
					}
				});
			};
		case ACTION_IDS.DELETE:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Delete Permission',
					content: 'Are you sure you want to delete this Permission?',
					footer: (
						<CustomFooter
							agreeLabel={BUTTON_LABELS.AGREE}
							disagreeLabel={BUTTON_LABELS.DISAGREE}
							onAgreeClick={onAgreeDeletePermission}
							onDisagreeClick={onDisAgreeDeletePermission}
						/>
					)
				});
			};
		case ACTION_IDS.ADD:
			return () => {
				history.push({
					pathname: ESettingV2URL.CREATE_PERMISSION_URL
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
